// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"d0527588","162":"bb6fb04d","585":"30e3db83","605":"fa7b010b","611":"e88be7ca","783":"60b4d8d6","833":"5cb884b8","928":"7994fc00"}[chunkId] + ".css";
};